import { Component, Input } from '@angular/core';
import { Svg, SvgIllustration } from '@smooved/ui';

@Component({
    selector: 'app-minor-service',
    template: `
        <div class="u-flex-row u-flex-align-items-center" [ngClass]="{ 'u-margin-bottom-half': !last }">
            <app-svg
                *ngIf="icon"
                [extraClass]="'u-color-muted'"
                [width]="'24px'"
                [height]="'24px'"
                [name]="icon"
                class="u-margin-right-half"
            ></app-svg>
            <smvd-ui-svg-illustration
                *ngIf="illustration"
                [svg]="illustration"
                class="u-margin-right-half u-padding-xs u-padding-left-none"
            ></smvd-ui-svg-illustration>
            <a
                [routerLink]="routerLink"
                *ngIf="routerLink; else hrefLink"
                class="u-flex-row u-flex-align-items-center u-link-no-style u-color-text"
            >
                <h4 class="u-margin-right-half">{{ title }}</h4>
                <app-svg [width]="'24px'" [height]="'24px'" [name]="svg.ChevronRight"></app-svg>
            </a>
            <ng-template #hrefLink>
                <a [href]="href" class="u-flex-row u-flex-align-items-center u-link-no-style u-color-text" *ngIf="!routerLink">
                    <h4 class="u-margin-right-half">{{ title }}</h4>
                    <app-svg [width]="'24px'" [height]="'24px'" [name]="svg.ChevronRight"></app-svg>
                </a>
            </ng-template>
        </div>
    `,
    styleUrls: ['./minor-service.component.scss'],
})
export class MinorServiceComponent {
    @Input() public illustration: SvgIllustration;
    @Input() public icon: Svg;
    @Input() public title: string;
    @Input() public last: boolean;
    @Input() public routerLink: string;
    @Input() public href: string;

    public svg = Svg;
}
